
  import { 
    defineComponent, 
    computed, 
    SetupContext,
    PropType
  } from "vue";
  import NativeClient from "@/client/native-client";
  import ShoppingIngredientListItem from "@/components/shoppingList/ShoppingIngredientListItem.vue";
  import { ShoppingListCheckedFoodListItem, ShoppingListFoodListItem } from "@/types/shoppingList"
  
  export default defineComponent({
    name: "ShoppingCheckedList",
    components: { ShoppingIngredientListItem },
    props: {
      /** 食材リスト */
      foodList: {
        type: Array as PropType<ShoppingListCheckedFoodListItem[]>,
        default: () => null
      },
      /** 食材が存在しない場合のメッセージ */
      noElementMessage: {
        type: String,
        required: true
      }
    },
    setup(props, context: SetupContext) {
      NativeClient.sendDebugLog("ShoppingCheckedList setUp start foodList = " + JSON.stringify(props.foodList));

      // 定数
      const checkedTitle = "チェック済み";
      const clearButtonTitle = "すべてクリア";
      const tappedClearButton = () => {
        NativeClient.sendDebugLog("ShoppingCheckedList tappedClearButton start");
        if (props.foodList != null) {
          NativeClient.sendDebugLog("ShoppingCheckedList tappedClearButton clear");
          context.emit("on-clear");
        }
      }

      // 食材リスト
      const getFoodList = () => {
        if (props.foodList == null) {
          NativeClient.sendDebugLog("ShoppingCheckedList getFoodList no exist");
          return [];
        }
        NativeClient.sendDebugLog("ShoppingCheckedList getFoodList foodList = " + JSON.stringify(props.foodList));
        const result: Array<ShoppingListFoodListItem> = [];
        for (const items of props.foodList) {
          for (const item of items.items) {
            result.push(item);
          }
        }
        return result;
      };
  
      const styleNoElement = computed(() => {
        NativeClient.sendDebugLog("ShoppingCheckedList styleNoElement");
        if (props.foodList == null) {
          NativeClient.sendDebugLog("ShoppingCheckedList styleNoElement null branch");
          return { display: `table`, visibility: `hidden` };
        } else if (props.foodList.length == 0) {
          NativeClient.sendDebugLog("ShoppingCheckedList styleNoElement no element branch");
          return { display: `table`, visibility: `visible` };
        }
        return { display: `none` };
      });
      const checkClick = (id: number, check: boolean) => {
        // checkは押された後の値
        NativeClient.sendDebugLog("ShoppingCheckedList checkClick id = " + id + ", check = " + check);
        context.emit("check-click", id, check)
      }
      const editClick = (id: number) => {
        NativeClient.sendDebugLog("ShoppingCheckedList editClick id = " + id);
        context.emit("edit-click", id);
      };

      return {
        checkedTitle,
        clearButtonTitle,
        tappedClearButton,
        getFoodList,
        styleNoElement,
        checkClick,
        editClick
      };
    }
  });
  